import React, {Component, Fragment} from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import * as InitStatus from "../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../utils/FetchHelper";
import {browser} from "../../utils/BrowserHelper";
import GraphDate from "../statistics/common/GraphDate";
import {makeGraphCategoryDate, thisMondayDate, now} from "../statistics/common/CommonHelper";
import {setActiveDate, setActiveDateIndex, setActiveDateType, setHoverDateIndex, setStandardDate} from "../../actions/statistics/statisticsActions";
import { connect } from "react-redux";
import autobind from "autobind-decorator";
import moment from "moment/moment";
import {balloon} from "../statistics/common/GraphBalloon";
import {graphConfig} from "./DashboardTrendGraphConfig";
import classnames from 'classnames';
import If from "../common/control/If";
import RetryView from "../statistics/common/RetryView";
import {addPrefix, isDaumBlogDomain} from "../../utils/UriUtil";

@connect(state => ({
  standardDate: state.statistics.standardDate,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
  hoverDateIndex: state.statistics.hoverDateIndex,
  activeDateIndex: state.statistics.activeDateIndex,
  minDate: state.statistics.minDate
}), dispatch => ({
  handleSetStandardDate(standardDate) {
    dispatch(setStandardDate(standardDate))
  },
  // 활성화된 날짜 변경
  handleSetActiveDate(activeDate) {
    dispatch(setActiveDate(activeDate))
  },
  // 활성화된 날짜 타입 변경 (day, week, month)
  handleSetActiveDateType(activeDateType) {
    dispatch(setActiveDateType(activeDateType))
  },
  // 선택된 날짜의 Index
  handleSetActiveDateIndex(activeDateIndex) {
    dispatch(setActiveDateIndex(activeDateIndex))
  },
  // hover된 날짜의 Index
  handleSetHoverDateIndex(hoverDateIndex) {
    dispatch(setHoverDateIndex(hoverDateIndex))
  },
}))
class DashboardTrend extends Component {

  // 그레프 초기화
  constructor(props) {
    super(props);
    this.normalBullet = isDaumBlogDomain() ? "//t1.daumcdn.net/daumblog_admin/static/chart/lineChart-bullet-normal.svg" : "//t1.daumcdn.net/tistory_admin/static/chart/lineChart-bullet-normal.svg";
    this.activeBullet = isDaumBlogDomain() ? "//t1.daumcdn.net/daumblog_admin/static/chart/lineChart-bullet-active.svg" : "//t1.daumcdn.net/tistory_admin/static/chart/lineChart-bullet-active.svg";
    this.rootChart = null;
    this.chart = null;
    this.browser = browser();
    this.state = {
      initialized: InitStatus.INIT_READY,
      dataProvider: [],
      categoryDate: []
    };

    this.config = Object.assign({}, graphConfig);
    this.config.graphs[0].balloonFunction = (item) => balloon(item, "count", "방문수", this.props.minDate);
  }

  // Mount후 그레프 초기화값셋팅과 API 호출
  componentDidMount() {
    this.props.handleSetStandardDate(now());
    this.props.handleSetActiveDateType("day");
    this.getTrendData();
    this.setGraphListeners();
  }

  // Watching후 변경된값에따라 API을 호출한다.
  shouldComponentUpdate(nextProps, nextState) {

    if (this.checkChangeGrapItemStyle(nextProps)) {
      const {hoverDateIndex} = this.props;
      this.changeGraphItemStyle(hoverDateIndex, "over");
    }

    return true;
  }

  // Timestamp값을 Index번호로 찾아서 리턴한다.
  @autobind
  getTimestampByIndex(index) {
    return this.rootChart.dataProvider[index].timestamp;
  }

  // 그래프의 스타일을 변경할지 여부를 판단한다.
  @autobind
  checkChangeGrapItemStyle(nextProps) {
    const {hoverDateIndex} = this.props;
    if (hoverDateIndex == null || nextProps.hoverDateIndex == hoverDateIndex) {
      return false;
    }

    return true;
  }


  // IE 버그 대응
  @autobind
  changeSVGStyleForIe() {
    if (this.browser.isIE || this.browser.isEdge) {
      const svgGroups = document.querySelectorAll('.amcharts-graph-line clipPath');
      Array.prototype.forEach.call(svgGroups, function (svgGroup) {
        const rect = svgGroup.getElementsByTagName("rect");
        rect[0].setAttribute("y", 3); // 3 is the lineTinkness
      })
    }
  }

  // 그레프 Event 리스터를 등록한다.
  setGraphListeners() {
    this.config.listeners = [
      {  // 그래프 클릭 이벤트
        event: "clickGraphItem", method: (e) => {
          this.changeActiveCategory(e.index, true);
        }
      }, { // 애니메이션 종료 이벤트
        event: "animationFinished", method: (e) => {
          this.animationFinished(e);
        }
      }, { // 액션 변화 이벤트 (hover)
        event: "changed", method: (e) => {
          this.graphDataChangeEvent(e);

        }
      }, { // 최초 init 이벤트
        event: "init", method: (e) => {
          this.rootChart = e.chart;
        }
      }
      , { // drawn 이벤트
        event: "drawn", method: (e) => {
          this.changeSVGStyleForIe();
        }
      }
    ];
  }

  // 애니메이션 완료후 호출될 내용
  @autobind
  animationFinished(e) {
    if (this.rootChart) {
      this.changeActiveCategory((this.rootChart.dataProvider.length - 1), true);
    }
  }

  // 그래프의 데이터값 변경후 호출될 내용
  @autobind
  graphDataChangeEvent(e) {
    if (e.index == null || isNaN(e.index)) return;

    this.props.handleSetHoverDateIndex(e.index);
    this.changeGraphItemStyle(e.index);
  }


  // 그래프의 스타일을 변경한다.
  @autobind
  changeGraphItemStyle(index) {
    if (this.rootChart == null || this.rootChart.dataProvider[index] == undefined) return;

    const {dataProvider} = this.state;
    let newDataProvider = [];
    dataProvider.map((item, itemIndex) => {
      let customBulletField = (itemIndex == index) ? this.activeBullet : this.normalBullet;
      newDataProvider.push({...item, customBulletField: customBulletField});
    });

    this.setState({dataProvider: newDataProvider}, () => {
      const date = this.getTimestampByIndex(this.props.hoverDateIndex);
      this.rootChart.chartCursor.showCursorAt(date);
    });
  }

  // 그래프의 활성화된 카테고리 정보리르 변경한다.
  @autobind
  changeActiveCategory(index) {

    if (this.rootChart == null || this.rootChart.dataProvider[index] == undefined) return;

    const date = this.getTimestampByIndex(index);
    const activeDate = moment(date).format(this.defaultFormat);
    this.props.handleSetActiveDateIndex(index);
    this.props.handleSetHoverDateIndex(index);
    this.props.handleSetActiveDate(activeDate);
    this.changeGraphItemStyle(index, "over");
  }


    // Trend 정보를 호출한다.
    getTrendData = () => {
        const {dispatch} = this.props;
        this.setState({initialized: InitStatus.INIT_DOING}, ()=> {
        fetch(addPrefix("/manage/statistics/dashboard/trend.json"), {
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            retries: 2,
            retryDelay: 300,
            retryOn: [500]
        })
            .then(jsonResponseHandler(dispatch))
            .then(res => res.json())
            .then(res => this.defaultDataProvider(res, "day", now(), 30))
            .then(res => {
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                    dataProvider: res.data,
                    categoryDate: makeGraphCategoryDate(res.data),
                })
            })
            .catch(e => {
                console.log('error:', e);
                this.setState({
                    initialized: InitStatus.INIT_FAIL});
                })
        });
  };

  // 그래프를 그리기위해 모든값이 정확하게 만들어져하기떄문에 데이터체킹을 수행한다.
  defaultDataProvider = (result, activeDateType, standardDate, gapCount) => {
    if (result.data.length == gapCount) {
      result.data.map((item) => {
        item.customBulletField = this.normalBullet;
        item.activeDateType = activeDateType;
      });
      return result;
    }

    let tempStandardDate = (standardDate == 'week') ? thisMondayDate(standardDate) : standardDate;
    let defaultResult = Object.assign({}, result, {data: []});

    for (let cursor = 0; cursor < gapCount; cursor++) {
      let existItem = result.data.filter((item) => {
        return (moment(item.timestamp).format("YYYY-MM-DD") == moment(tempStandardDate).add(-cursor, activeDateType).format("YYYY-MM-DD"));
      });

      if (existItem.length > 0) {
        defaultResult.data.push({
          ...existItem[0],
          customBulletField: this.normalBullet,
          activeDateType: activeDateType
        })
      }
      else {
        defaultResult.data.push({
          timestamp: moment(standardDate).add(-cursor, activeDateType).format("YYYY-MM-DD") + "T00:00:00.000Z",
          count: 0,
          customBulletField: this.normalBullet,
          activeDateType: activeDateType
        });
      }
    }

    defaultResult.data = defaultResult.data.reverse();
    return defaultResult;
  };


  // 로딩 렌더링
  renderLoading() {
    return <div className="date_loading">
      <div className="inner_g"><span className="ico_blog ico_loading">로딩중입니다.</span></div>
    </div>
  }


  // Root 렌더링
  render() {
    const {dataProvider, categoryDate, initialized} = this.state;
    const config = Object.assign({}, this.config, {dataProvider: dataProvider});
    const isIe = this.browser.isIE || this.browser.isEdge;
    const {isDoing, isFail, isSuccess} = InitStatus.init(initialized, dataProvider);

    return (
      <Fragment>
        <div className={classnames({"box_blog blog_graph dashboard_graph": true, "ie": isIe})}>
          <div className="wrap_graph">
            <div className="graph_comm">
              <If condition={isDoing}>{this.renderLoading()}</If>
              <If condition={isFail}><RetryView retryCallback={this.getTrendData}/></If>
              <If condition={!isFail}>
                <Fragment>
                  <If condition={!isDoing}>
                    <div className="box_graph_type1">
                      <AmCharts.React
                        style={{height: "244px"}}
                        className="line_chart day"
                        options={config}
                        ref={element => (this.chart = element)}
                      />
                    </div>
                  </If>

                  <div className="wrap_date">
                    <GraphDate
                      categoryDate={categoryDate}
                      gap={this.gap}
                      dateWidth="27.7px"
                      usePagination={false}
                      useActiveDate={false}
                    />
                  </div>
                </Fragment>
              </If>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default DashboardTrend;
